<template>
    
    <a-card>
      
    <div>
        <h3 style="text-align: center;margin:20px 0 40px">项目经费预算情况</h3>
        <a-form layout="horizontal"  ref="ruleForm" labelAlign="right" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <a-row :gutter="[24,8]">
                <a-col :span="24"><h4>经费来源预算</h4></a-col>
                <a-col :span="24">
                    <span  style="margin-bottom:10px;display:block" v-for="(item,key) in rootIn" :key="key">
                        {{ key+1 }}、{{ item.costName }}: <a-input-number v-model:value="rootIn[key].cost"/>
                        <span  style="margin-left:20px;" v-if="rootIn[key].childrenFund[0]">其中：</span>
                        <span style="display:inline-block;margin-right:20px" v-for="(items,keys) in rootIn[key].childrenFund" :key="keys">
                            {{ items.costName }}: <a-input-number v-model:value="rootIn[key].childrenFund[keys].cost"/>
                        </span>
                        <br>
                    </span>
                </a-col>
                <a-col :span="24" style="text-align: center;">
                    <a-button type="primary" html-type="submit" @click="getrootIn(rootIn)">
                        经费来源预算保存
                    </a-button>
                </a-col>
                
                <a-col :span="24"><h4>经费支出预算</h4></a-col>
                <a-col :span="24">
                    <span  style="margin-bottom:10px;display:block" v-for="(item,key) in payOut" :key="key">
                        {{ key+1 }}、{{ item.costName }}: <a-input-number v-model:value="payOut[key].cost"/>
                        <span  style="margin-left:20px;" v-if="payOut[key].childrenFund[0]">其中：</span>
                        <span style="display:inline-block;margin-right:20px" v-for="(items,keys) in payOut[key].childrenFund" :key="keys">
                            {{ items.costName }}: <a-input-number v-model:value="payOut[key].childrenFund[keys].cost"/>
                        </span>
                        <br>
                    </span>
                </a-col>
                <a-col :span="24" style="text-align: center;">
                    <a-button type="primary" html-type="submit" @click="getrootIn(payOut)">
                        经费支出预算保存
                    </a-button>
                </a-col>
            </a-row>
        </a-form>
        
    </div>
    </a-card>
</template>
<script>
import store from '@/store';
import {formMixin} from "@/mixins";
import {projectFundRecord,projectFundModel} from "@/api/TechnologieprojekteApply";
import { filterObj } from "@/utils/util";
import {  postJson } from "@/utils/http/service";

export default {
    name: "项目经费预算情况",
    components: {},

    mixins: [formMixin],
    data() {
        return {
            rootIn:null, //来源
            payOut:null, //支出
            form: {
                    id: null,
            },
            rules: {
                    id: [],
            },

            options: [],
            addUpdata: true,
            rootChange: null
        }
    },
    
    computed: {
            submitUrl() {
                    return projectFundRecord.saveOrUpdate
                    }
        },
    mounted() {
        if(this.$route.query.id){
            this.onEdit()
        }else{
            this.getMobanRootIn()
            this.getMobanPayOut()
        }
    },
    methods: {
        parentSave(){
            this.getrootIn(this.rootIn)
            this.getrootIn(this.payOut)
        },
        getrootIn(ChangeData){
            
            this.rootChange = {
                    "projectId": store.getters.TechnologieTypeId.projectId,
                    "classification": store.getters.TechnologieTypeId.classification,
                    "projectFundRecordVos": ChangeData
            }
            if(this.addUpdata){
                postJson({
                    url: projectFundRecord.updateData,
                    params: filterObj(this.rootChange),
                    method: 'post',
                    returnMsg: true
                }).then(() => {
                        this.$message.success("修改成功")
                })
            }else{
                postJson({
                    url: projectFundRecord.saveOrUpdate,
                    params: filterObj(this.rootChange),
                    method: 'post',
                    returnMsg: true
                }).then(() => {
                        this.$message.success("保存成功")
                })
            }
        },
        getMobanRootIn() {
            this.addUpdata = false
            this.getAction({
                url: projectFundModel.getFundModel,
            }).then(res => {
                this.rootIn = res[0]
                this.rootIn.map(item => {
                    item.projectId = store.getters.TechnologieTypeId.projectId
                    item.classification = store.getters.TechnologieTypeId.classification
                    item.childrenFund.map(items => {
                        items.projectId = store.getters.TechnologieTypeId.projectId
                        items.classification = store.getters.TechnologieTypeId.classification
                    })
                })
            })
        },

        
        getMobanPayOut() {
            this.addUpdata = false
            this.getAction({
                url: projectFundModel.getFundModel,
            }).then(res => {
                this.payOut = res[1]
                this.payOut.map(item => {
                    item.projectId = store.getters.TechnologieTypeId.projectId
                    item.classification = store.getters.TechnologieTypeId.classification
                    item.childrenFund.map(items => {
                        items.projectId = store.getters.TechnologieTypeId.projectId
                        items.classification = store.getters.TechnologieTypeId.classification
                    })
                })
            })
        },

        onEdit() {
            this.getAction({
                url: projectFundRecord.fundDetail,
                params: { 
                    projectId: store.getters.TechnologieTypeId.projectId,
                 }
            }).then(res => {
                if(res[0]){
                    this.addUpdata = true,
                    this.rootIn = res[0]
                    this.rootIn.map(item => {
                        item.projectId = store.getters.TechnologieTypeId.projectId
                        item.classification = store.getters.TechnologieTypeId.classification
                        item.childrenFund.map(items => {
                            items.projectId = store.getters.TechnologieTypeId.projectId
                            items.classification = store.getters.TechnologieTypeId.classification
                        })
                    })
                }else{
                    this.getMobanRootIn()
                }

                if(res[1]){
                    this.addUpdata = true,
                    this.payOut = res[1]
                    this.payOut.map(item => {
                        item.projectId = store.getters.TechnologieTypeId.projectId
                        item.classification = store.getters.TechnologieTypeId.classification
                        item.childrenFund.map(items => {
                            items.projectId = store.getters.TechnologieTypeId.projectId
                            items.classification = store.getters.TechnologieTypeId.classification
                        })
                    })
                }else{
                    this.getMobanPayOut()
                }
            })
        },
    },
}
</script>
<style scoped lang="less">
</style>
